import React, { useMemo, useCallback } from 'react';
import { useQuery } from 'react-query';
import { getData } from 'src/Utils/api';
import { FormSection, SectionTitle, FormGrid, SectionBox } from './styles';
import { FormField } from 'src/Components';
import SearchableSelect from '../Common/SearchableSelect/SearchableSelect';
import { FormGridItem } from 'src/Views/CreateTicketPage/TicketForm/styles';
var formFields = [
    {
        key: 'external_client_first_name',
        label: 'Nombre',
        placeholder: 'Ingresa el nombre del cliente',
        type: 'text'
    },
    {
        key: 'external_client_last_name',
        label: 'Apellido',
        placeholder: 'Ingresa el apellido del cliente',
        type: 'text'
    },
    {
        key: 'external_client_email',
        label: 'Email',
        placeholder: 'nombre@ejemplo.com',
        type: 'email'
    },
    {
        key: 'external_client_phone',
        label: 'Teléfono',
        placeholder: 'Ej. 11 2345 6789',
        type: 'text'
    }
];
export var ApplicantInformationSection = function (_a) {
    var formData = _a.formData, errors = _a.errors, onInputChange = _a.onInputChange, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.canUseStructuredClient, canUseStructuredClient = _c === void 0 ? false : _c;
    var _d = useQuery(['contacts', formData.apartment_id, formData.relation], function () { return getData("/apartments/" + formData.apartment_id + "/contacts").then(function (res) { return res.apartment_contacts || []; }); }, { enabled: !!formData.apartment_id && !!formData.relation }).data, allApartmentContacts = _d === void 0 ? [] : _d;
    var getFilteredContacts = useCallback(function () {
        if (!formData.relation || !allApartmentContacts.length)
            return [];
        var relationshipMapping = { 'proprietary': 'P', 'tenant': 'I', 'both': 'A' };
        var expectedRelationship = relationshipMapping[formData.relation] || formData.relation;
        return allApartmentContacts.filter(function (apartmentContact) {
            return apartmentContact.relationship === expectedRelationship;
        });
    }, [formData.relation, allApartmentContacts]);
    var contacts = useMemo(function () { return getFilteredContacts(); }, [getFilteredContacts]);
    var clientSelectionOptions = useMemo(function () {
        return canUseStructuredClient
            ? [
                { value: 'existing', label: 'Cliente existente' },
                { value: 'new', label: 'Nuevo cliente' },
                { value: 'other', label: 'Otro' }
            ]
            : [{ value: 'other', label: 'Otro' }];
    }, [canUseStructuredClient]);
    return (React.createElement(FormGridItem, null,
        React.createElement(FormSection, { disabled: disabled },
            React.createElement(SectionTitle, null, "Informaci\u00F3n del solicitante"),
            React.createElement(SectionBox, { mb: 2 },
                React.createElement(SearchableSelect, { label: "Seleccione cliente", value: formData.client_selection, onChange: function (value) {
                        onInputChange('client_selection', value);
                        if (value !== 'existing')
                            onInputChange('apartment_contact_id', null);
                    }, options: clientSelectionOptions, placeholder: "Selecciona tipo de cliente" })),
            formData.client_selection === 'existing' && (React.createElement(SectionBox, null,
                React.createElement(SearchableSelect, { label: "Seleccione contacto", value: formData.apartment_contact_id, onChange: function (value) { return onInputChange('apartment_contact_id', value); }, options: contacts.map(function (apartmentContact) { return ({
                        value: apartmentContact.id,
                        label: apartmentContact.contact_name
                    }); }), placeholder: "Seleccione contacto", error: errors.apartment_contact_id }))),
            formData.client_selection === 'new' && (React.createElement(FormGrid, { container: true, spacing: 2 }, formFields.map(function (field) { return (React.createElement(FormField, { key: field.key, label: field.label, placeholder: field.placeholder, value: formData[field.key], onChange: function (value) { return onInputChange(field.key, value); }, type: field.type, error: !!errors[field.key], helperText: errors[field.key], disabled: disabled })); }))),
            formData.client_selection === 'other' && (React.createElement(FormGrid, { container: true, spacing: 2 }, formFields.filter(function (field) { return field.key !== 'external_client_email'; }).map(function (field) { return (React.createElement(FormField, { key: field.key, label: field.label, placeholder: field.placeholder, value: formData[field.key], onChange: function (value) { return onInputChange(field.key, value); }, type: field.type, error: !!errors[field.key], helperText: errors[field.key], disabled: disabled })); }))))));
};
export default ApplicantInformationSection;
